<template>
  <div class="sippulse">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>Ramal <small v-if="!activeIntegration">(Inativo)</small><small v-else>({{ this.extension }})</small></h4>
            <span v-if="activeIntegration">{{ this.$store.state.auth.organization.domain }}</span>
          </div>
        </div>

        <ErrorAlert
          :error="error"
          :context="{ ramal: extension }"
          class="mt-2" />
        <div
          v-if="successMessage"
          class="alert alert-success mt-2"
          role="alert">
          {{ successMessage }}
        </div>

        <div class="config-form mt-2">
          <div class="form-group row">
            <label
              for="extension"
              class="col-sm-4 col-form-label">Ramal</label>
            <div class="col-sm-8">
              <select
                class="form-control user-extension"
                id="extension"
                v-model="extensionId"
                :disabled="!isExtensionChangeAllowed"
                @change="onChangeExtension">
                <option
                  v-for="option in extensionsOptions"
                  :key="option.value"
                  :value="option.value">
                  {{ option.text }}
                </option>
              </select>
              <small
                v-if="!isExtensionChangeAllowed"
                class="form-text text-muted">O ramal é vinculado na criação do usuário. Para alterá-lo, entre em contato com o suporte.</small>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="password"
              class="col-sm-4 col-form-label">Senha</label>
            <div class="col-sm-8">
              <div class="input-group">
                <input
                  id="password"
                  type="password"
                  class="form-control"
                  autocomplete="new-password"
                  v-model="password"
                  required>
                <span class="input-group-append">
                  <a
                    class="input-group-text"
                    href="#"
                    @click.prevent="togglePasswordVisibility()">
                    <i class="ik ik-eye" />
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="firstName"
              class="col-sm-4 col-form-label">Nome</label>
            <div class="col-sm-8">
              <input
                id="firstName"
                type="text"
                class="form-control"
                v-model="firstName">
            </div>
          </div>
          <div class="form-group row">
            <label
              for="lastName"
              class="col-sm-4 col-form-label">Sobrenome</label>
            <div class="col-sm-8">
              <input
                id="lastName"
                type="text"
                class="form-control"
                v-model="lastName">
            </div>
          </div>
          <div class="form-group row">
            <label
              for="bina"
              class="col-sm-4 col-form-label">BINA</label>
            <div class="col-sm-8">
              <input
                id="bina"
                type="text"
                class="form-control"
                v-model="bina">
            </div>
          </div>
          <div class="text-center">
            <a
              class="link advanced-options"
              @click="toggleAdvancedOptions">{{ showAdvancedOptions ? 'Ocultar' : 'Exibir' }} Configurações Avançadas</a>
          </div>
          <hr class="advanced-options-hr">
          <div
            class="form-group row"
            v-if="showAdvancedOptions">
            <div class="col-sm-4 col-form-label">
              <label
                for="external"
                title="Registrar o Ramal em outro aplicativo externo. Ex.: Zoiper, Mizu, Grandstream, etc.">
                Registro externo?&nbsp;
              </label>
              <a
                href="https://youtu.be/GooxNTpPafA?si=aIGP5qhsqsaXFsG1"
                target="_blank">
                <font
                  title="Como usar o Registro Externo?"
                  size="4"
                  color="black">
                  <i class="ik ik-youtube" />
                </font>
              </a>
            </div>
            <div class="col-sm-8">
              <input
                id="external"
                type="checkbox"
                class="form-control"
                title="Registrar o Ramal em outro aplicativo externo. Ex.: Zoiper, Mizu, Grandstream, etc."
                v-model="external">
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-center mt-2">
            <sippulse-new />
            <div class="buttons">
              <!-- TEL-2395: a API não remove mais a integração de ramal (403) -->
              <button
                v-if="false"
                type="button"
                class="btn btn-outline-danger mr-2"
                @click.prevent="deleteIntegration">Desativar</button>
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">{{ labelSubmit }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import SippulseNew from '@/components/Integration/SippulseNew.vue'
import { EventBus } from '@/services/event-bus'

export default {
  name: 'IntegrationSippulse',
  components: {
    SippulseNew
  },
  data () {
    return {
      error: null,
      successMessage: null,
      integration: null,
      configReady: false,
      extensionIntegration: null,
      extensionId: null,
      extensions: [],
      extensionsOptions: [],
      extension: null,
      password: null,
      bina: null,
      firstName: null,
      lastName: null,
      external: false,
      showAdvancedOptions: false,
      isExtensionChangeAllowed: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      EventBus.$on('sippulse-extension-created', _ => this.loadExtensions(true))
      this.loadIntegration()
      this.loadExtensions()
      this.loadExtensionChangeRollout()
    })
  },
  methods: {
    loadExtensionChangeRollout () {
      loopback
        .get('/rollout?featureFlag=extension-change')
        .then(rollout => {
          this.isExtensionChangeAllowed = rollout === 'ALLOWED'
        })
    },
    loadIntegration () {
      return loopback
        .get(`/integrations?filter[where][gateway]=sippulse`)
        .then(integrations => {
          this.integration = integrations.pop()
          if (this.integration && this.integration.metadata && this.integration.metadata.id) {
            if (this.integration.metadata.hasOwnProperty('external')) {
              this.external = this.integration.metadata.external
              if (this.external === true) {
                this.showAdvancedOptions = true
              }
            }
            this.assignExtensionProps(this.integration.metadata)
          }
        })
        .catch(err => { this.$emit('onError', err) })
    },
    saveIntegration () {
      if (this.extensionId) {
        this.error = null
        const extensionParams = {
          id: this.extensionId,
          gravar_audio: true,
          email_address: this.$store.state.auth.user.email
        }
        if (this.password) extensionParams.senha = this.password
        if (this.firstName) extensionParams.first_name = this.firstName
        extensionParams.last_name = this.lastName ? this.lastName : ''
        extensionParams.bina = this.bina ? this.bina : null
        loopback
          .patch('/extensions', extensionParams)
          .then(extension => {
            const integrationParams = {
              gateway: 'sippulse',
              webhook: false,
              metadata: {
                id: extension.id,
                domain: extension.domain,
                username: extension.ramal,
                password: extension.senha,
                firstName: extension.first_name,
                lastName: extension.last_name,
                webhook_body_version: extension.webhook_body_version,
                external: this.external
              }
            }
            if (extension.bina) integrationParams.metadata.bina = extension.bina
            if (this.integration) integrationParams.id = this.integration.id
            loopback
              .patch('/integrations', integrationParams)
              .then(integration => {
                this.integration = integration
                this.assignExtensionProps(this.integration.metadata)
                this.showSuccess('Integração Ramal atualizada com sucesso!')
              })
              .catch(err => {
                this.error = err
              })
          })
          .catch(err => {
            this.error = err
            // TEL-2243: o `friendly` do interceptor ja resolve `details.messages`.
            // O `ramal` cai no FIELD_PASSTHROUGH: o `extension.js` responde em pt-BR
            // com a faixa exata, entao o texto dele passa inteiro em vez de ser
            // reescrito aqui. Montar `lines` nesta tela devolvia o texto do LoopBack
            // em ingles e ainda sobrescrevia a traducao.
          })
      }
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.configReady = false
          this.integration = null
          this.extension = null
          this.extensionId = null
          this.extensionIntegration = null
          this.password = null
          this.firstName = null
          this.lastName = null
          this.bina = null
          this.external = false
          this.showSuccess('Integração Ramal removida com sucesso!')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    loadExtensions (forceReload = false) {
      return new Promise(resolve => {
        if (this.extensions.length > 0 && !forceReload) return resolve()
        loopback
          .get('/extensions?filter[order]=ramal')
          .then(extensions => {
            if (extensions && extensions.length > 0) {
              this.extensions = extensions
              this.extensionsOptions = extensions.reduce((list, extension) => {
                let text = extension.ramal
                if (extension.first_name) text += ` - ${extension.first_name}`
                if (extension.last_name) text += ` ${extension.last_name}`
                list.push({
                  text,
                  value: extension.id
                })
                return list
              }, [])
            }
            return resolve()
          })
          .catch(err => { this.$emit('onError', err) })
      })
    },
    onChangeExtension (event) {
      if (event.target && event.target.value) {
        const extension = this.extensions.find(ext => String(ext.id) === String(event.target.value))
        this.assignExtensionProps(extension)
      }
    },
    assignExtensionProps (extension) {
      this.extensionId = extension.id
      this.extension = extension.username || extension.ramal
      this.password = extension.password || extension.senha
      this.firstName = extension.firstName || extension.first_name
      this.lastName = extension.lastName || extension.last_name
      this.bina = extension.bina
      this.configReady = true
    },
    togglePasswordVisibility () {
      const input = $('#password')
      if (input[0].type === 'password') {
        input[0].type = 'text'
      } else {
        input[0].type = 'password'
      }
    },
    toggleAdvancedOptions () {
      this.showAdvancedOptions = !this.showAdvancedOptions
    },
    showSuccess (message) {
      this.successMessage = message
      if (this._successTimer) clearTimeout(this._successTimer)
      this._successTimer = setTimeout(() => { this.successMessage = null }, 4000)
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    },
    activeIntegration () {
      return this.integration && this.integration.gateway === 'sippulse'
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    }
  },
  watch: {
    bina: function (value) {
      if (value) this.bina = value.replace(/[^+0-9]/, '')
    },
    password: function (value, oldValue) {
      if (value) {
        if (value.match(/["'`´ ]/)) {
          this.error = {
            message: 'Não é permitido utilizar espaços ou os seguintes caracteres de acentuação como senha: " \' ` ´'
          }
          this.password = value.replace(/["'`´ ]/, '')
        } else if (oldValue && !oldValue.match(/["'`´ ]/)) {
          this.error = null
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#external {
  width: 16px;
  height: 16px;
}
.advanced-options {
  font-size: 12px;
}
.advanced-options-hr {
  margin-top: 0px;
}
.state span {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/Integration/Sippulse.vue